import { useExperimentalFeature } from "@istari-frontend/experimental-features";
import { Navigate } from "react-router";

import { routes } from "~/routes";

export function RootRedirect({ replace = false }: { replace?: boolean }) {
  const { enabled: isSystemRedesignEnabled } = useExperimentalFeature("system-redesign");
  return <Navigate to={isSystemRedesignEnabled ? routes.SystemsDashboard : routes.Systems} replace={replace} />;
}
